module.exports = __webpack_public_path__ + "img/titan-glass.b1d28106.png";